import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import ActionButtonsFormularioAgricultura from 'components/forms/ActionButtonsFormularioAgricultura';
import { ContainerForm } from 'components/shared/container_form';
import {
  FormularioSecretariaMunicipalAgricultura,
  useFormularioSecretariaMunicipalAgriculturaStore,
} from '../../../../../../stores/forms/formularioAgricultura.store';
const Step3: React.FC = () => {
  const { formulario, setPartialForm } =
    useFormularioSecretariaMunicipalAgriculturaStore();

  // Validações baseadas nos campos do Step 3
  const validarCamposObrigatorios = () => {
    // Campos básicos obrigatórios
    const camposBasicosPreenchidos =
      formulario?.possui_escritorio_empaer !== null &&
      formulario?.desenvolve_projetos_empaer !== null &&
      formulario?.servidores_cedidos_empaer !== null &&
      //formulario?.servidor_empaer_cedido_municipio !== null &&
      formulario?.possui_escritorio_indea !== null &&
      formulario?.possui_unidade_sema !== null;

    // Se desenvolve projetos com EMPAER, o nome do projeto é obrigatório
    const projetoEmpaerValido =
      formulario?.desenvolve_projetos_empaer === false ||
      (formulario?.desenvolve_projetos_empaer === true &&
        formulario?.projeto_empaer_nome?.trim() !== '');

    // Se há servidores cedidos para EMPAER, pelo menos um nome deve estar preenchido
    const servidoresCedidosValido =
      formulario?.servidores_cedidos_empaer === false ||
      (formulario?.servidores_cedidos_empaer === true &&
        formulario?.nome_servidores_cedidos_empaer &&
        formulario?.nome_servidores_cedidos_empaer?.length > 0 &&
        formulario?.nome_servidores_cedidos_empaer?.every(
          (nome) => nome?.trim() !== '',
        ));

    // Se há servidor da EMPAER cedido para município, o nome é obrigatório
    // const servidorEmpaerCedidoValido =
    //   formulario?.servidor_empaer_cedido_municipio === false ||
    //   (formulario?.servidor_empaer_cedido_municipio === true &&
    //     formulario?.nome_servidor_empaer_cedido_municipio?.trim() !== '');

    return (
      camposBasicosPreenchidos &&
      projetoEmpaerValido &&
      servidoresCedidosValido
    );
  };

  const preencheuTodosCampos = validarCamposObrigatorios();

  const formularioInativo = preencheuTodosCampos;

  console.log(
    'nome_servidores_cedidos_empaer',
    formulario?.nome_servidores_cedidos_empaer,
  );

  console.log('typeof', typeof formulario?.nome_servidores_cedidos_empaer);

  const mascaraOrcamento = (valor: string) => {
    // Remove tudo que não é dígito
    const valorLimpo = valor.replace(/\D/g, '');

    // Se não tem valor, retorna vazio
    if (!valorLimpo) return '';

    // Converte para número e divide por 100 para ter os centavos
    const valorNumerico = parseInt(valorLimpo) / 100;

    // Formata como moeda brasileira
    return valorNumerico.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const checkRadio = (
    e: React.ChangeEvent<HTMLInputElement>,
    campo: keyof FormularioSecretariaMunicipalAgricultura,
  ) => {
    console.log('value', e.target.value);

    setPartialForm(campo, e.target.value === 'true');
  };

  const handleNomeServidorChange = (
    index: number,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (!formulario?.nome_servidores_cedidos_empaer) {
      setPartialForm('nome_servidores_cedidos_empaer', [e.target.value]);
      return;
    }
    const newNomesServidores = [
      ...(formulario?.nome_servidores_cedidos_empaer || []),
    ];
    newNomesServidores[index] = e.target.value;
    setPartialForm('nome_servidores_cedidos_empaer', newNomesServidores);
  };

  const removerCampoServidor = (index: number) => {
    const newNomesServidores = [
      ...(formulario?.nome_servidores_cedidos_empaer || []),
    ];
    newNomesServidores.splice(index, 1);
    setPartialForm('nome_servidores_cedidos_empaer', newNomesServidores);
  };

  const adicionarCampoServidor = () => {
    if (!formulario?.nome_servidores_cedidos_empaer) {
      setPartialForm('nome_servidores_cedidos_empaer', ['']);
      return;
    }
    const newNomesServidores = [
      ...(formulario?.nome_servidores_cedidos_empaer || []),
    ];
    newNomesServidores.push('');
    setPartialForm('nome_servidores_cedidos_empaer', newNomesServidores);
  };

  return (
    <>
      <ContainerForm title='Informações Gerais'>
        <Box
          sx={{ borderBottom: 1, borderColor: 'divider' }}
          gap={4}
          display={'flex'}
          flexDirection={'column'}
        >
          <FormControl>
            <FormLabel
              id='foreigner-label'
              sx={{
                color: '#333',
                fontWeight: 'bold',
              }}
            >
              O município possui escritórios da Empaer?
            </FormLabel>

            <RadioGroup
              aria-labelledby='foreigner-label'
              defaultValue={formulario?.possui_escritorio_empaer}
              name='radio-buttons-group'
              value={formulario?.possui_escritorio_empaer}
              onChange={(e) => checkRadio(e, 'possui_escritorio_empaer')}
            >
              <FormControlLabel value={true} control={<Radio />} label='Sim' />
              <FormControlLabel value={false} control={<Radio />} label='Não' />
            </RadioGroup>
          </FormControl>

          <FormControl component='fieldset'>
            <FormLabel component='legend' sx={{ fontWeight: 'bold', color: '#333' }}>
              O município desenvolve projetos junto com a Empaer?
            </FormLabel>
            <RadioGroup
              aria-label='empresa-parceria'
              name='empresa-parceria-radio-buttons-group'
              value={formulario?.desenvolve_projetos_empaer}
              onChange={(e) => checkRadio(e, 'desenvolve_projetos_empaer')}
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  flexWrap: 'wrap',
                }}
              >
                {' '}
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label='Sim'
                  sx={{
                    mr: formulario?.desenvolve_projetos_empaer === true ? 1 : 0,
                  }}
                />
                {formulario?.desenvolve_projetos_empaer === true && (
                  <TextField
                    id='project-name'
                    // label="Nome do projeto" // Pode ser redundante se o placeholder for claro
                    placeholder='Escreva o nome do projeto executado em parceria com a EMPAER'
                    variant='outlined'
                    value={formulario?.projeto_empaer_nome || ''}
                    onChange={(e) =>
                      setPartialForm('projeto_empaer_nome', e.target.value)
                    }
                    size='small' // Para melhor alinhamento vertical com o radio
                    sx={{ flexGrow: 1, minWidth: '250px' }} // Permite que o TextField cresça
                  />
                )}
              </Box>
              <FormControlLabel value={false} control={<Radio />} label='Não' />
            </RadioGroup>
          </FormControl>

          <FormControl component='fieldset' fullWidth margin='normal' required>
            <FormLabel component='legend' sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
              <Box component='span' sx={{ color: 'red', mr: 0.5 }}>
                *
              </Box>
              Há algum servidor do município cedido para Empaer?
            </FormLabel>
            <RadioGroup
              aria-label='servidores-cedidos-empaer'
              name='servidoresCedidosEmpaer'
              value={formulario?.servidores_cedidos_empaer}
              onChange={(e) => checkRadio(e, 'servidores_cedidos_empaer')}
            >
              <FormControlLabel
                value={true}
                control={<Radio required />}
                label='Sim'
              />
              <FormControlLabel
                value={false}
                control={<Radio required />}
                label='Não'
              />
            </RadioGroup>

            {formulario?.servidores_cedidos_empaer === true && (
              <Box sx={{ mt: 2, pl: 2, borderLeft: '2px solid #eee' }}>
                <Typography variant='body2' sx={{ mb: 3 }}>
                  Quais? (Preencha o nome completo dos servidores cedidos)
                </Typography>
                {(formulario?.nome_servidores_cedidos_empaer || []).map(
                  (nome, index) => (
                    <Box
                      key={index}
                      sx={{ display: 'flex', alignItems: 'center', mb: 2 }}
                    >
                      <TextField
                        label={`Servidor ${index + 1}`}
                        variant='outlined'
                        value={nome}
                        onChange={(e) =>
                          handleNomeServidorChange(
                            index,
                            e as React.ChangeEvent<HTMLInputElement>,
                          )
                        }
                        fullWidth
                        size='small'
                        required // Torna cada campo de nome de servidor obrigatório
                        placeholder='Nome completo do servidor'
                      />
                      <IconButton
                        onClick={() => removerCampoServidor(index)}
                        aria-label='Remover servidor'
                        disabled={
                          (formulario?.nome_servidores_cedidos_empaer || [])
                            .length === 1
                        } // Não permite remover se for o último campo
                        color='error'
                      >
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                    </Box>
                  ),
                )}
                <Button
                  variant='outlined'
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={adicionarCampoServidor}
                  size='small'
                >
                  Adicionar Servidor
                </Button>
              </Box>
            )}

            {/* Botão de submit de exemplo */}
            {/* <Button onClick={handleSubmit} variant="contained" sx={{ mt: 3 }}>
        Salvar Resposta
      </Button> */}
          </FormControl>

          {/* <FormControl component='fieldset'>
            <FormLabel component='legend' sx={{ fontWeight: 'bold', color: '#333' }}>
              Há algum servidor da Empaer cedido para o município?
            </FormLabel>
            <RadioGroup
              aria-label='empresa-parceria'
              name='empresa-parceria-radio-buttons-group'
              value={formulario?.servidor_empaer_cedido_municipio}
              onChange={(e) =>
                checkRadio(e, 'servidor_empaer_cedido_municipio')
              }
            >
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  flexWrap: 'wrap',
                }}
              >
                {' '}
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label='Sim'
                  sx={{
                    mr:
                      formulario?.servidor_empaer_cedido_municipio === true
                        ? 1
                        : 0,
                  }}
                />
                {formulario?.servidor_empaer_cedido_municipio === true && (
                  <TextField
                    id='project-name'
                    // label="Nome do projeto" // Pode ser redundante se o placeholder for claro
                    placeholder='Quais?'
                    variant='outlined'
                    value={
                      formulario?.nome_servidor_empaer_cedido_municipio || ''
                    }
                    onChange={(e) =>
                      setPartialForm(
                        'nome_servidor_empaer_cedido_municipio',
                        e.target.value,
                      )
                    }
                    size='small' // Para melhor alinhamento vertical com o radio
                    sx={{ flexGrow: 1, minWidth: '250px' }} // Permite que o TextField cresça
                  />
                )}
              </Box>
              <FormControlLabel value={false} control={<Radio />} label='Não' />
            </RadioGroup>
          </FormControl> */}

          <FormControl>
            <FormLabel
              id='foreigner-label'
              sx={{
                color: '#333',
                fontWeight: 'bold',
              }}
            >
              O município possui escritórios da Indea?
            </FormLabel>

            <RadioGroup
              aria-labelledby='foreigner-label'
              defaultValue={formulario?.possui_escritorio_indea}
              name='radio-buttons-group'
              value={formulario?.possui_escritorio_indea}
              onChange={(e) => checkRadio(e, 'possui_escritorio_indea')}
            >
              <FormControlLabel value={true} control={<Radio />} label='Sim' />
              <FormControlLabel value={false} control={<Radio />} label='Não' />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <FormLabel
              id='foreigner-label'
              sx={{
                color: '#333',
                fontWeight: 'bold',
              }}
            >
              O município possui unidade SEMA?
            </FormLabel>

            <RadioGroup
              aria-labelledby='foreigner-label'
              defaultValue={formulario?.possui_unidade_sema}
              name='radio-buttons-group'
              value={formulario?.possui_unidade_sema}
              onChange={(e) => checkRadio(e, 'possui_unidade_sema')}
            >
              <FormControlLabel value={true} control={<Radio />} label='Sim' />
              <FormControlLabel value={false} control={<Radio />} label='Não' />
            </RadioGroup>
          </FormControl>
        </Box>
        <ActionButtonsFormularioAgricultura disabled={!formularioInativo} />
      </ContainerForm>
    </>
  );
};

export default Step3;
